import React from 'react';
import Switch from '../atoms/Switch';
import { AutopilotCol } from './FlowBuilder.styles';

const DEFAULT_SUBTITLE = 'Send AI generated messages without approving';

const AutopilotToggleRow = ({ value, onChange, subtitle = DEFAULT_SUBTITLE }) => (
  <AutopilotCol>
    <div className="copy">
      <span className="heading">Autopilot</span>
      <span className="text">{subtitle}</span>
    </div>
    <div className="switch-holder">
      <Switch value={value} onChange={({ target: { value: checked } }) => onChange(checked)} />
    </div>
  </AutopilotCol>
);

export default AutopilotToggleRow;
